/* src/app/questionnaire/question/question.component.scss */
swiper-container {
  height: 100%;
  margin-top: 1em;
  padding: 1em;
}
swiper-slide {
  text-align: left;
  padding: 1em 1em 3em 1em;
  border-radius: 2em;
  background: #ffff00 url("./media/help.svg") no-repeat right top;
  background-size: 400px;
  display: block;
  position: relative;
  flex-direction: column;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  overflow: scroll;
  box-sizing: border-box;
}
.swiper-slide:not(.swiper-slide-active) > div {
  display: none;
}
.outerQuestion {
  width: 100%;
  display: table;
}
.question {
  padding: 0em 0em 1em;
  display: table-cell;
  font-family:
    "Times New Roman",
    Times,
    serif;
  font-size: 5.5vw;
}
.feedback {
  text-align: left;
  font-weight: 200;
  font-size: 4.5vw;
}
@media (min-width: 768px) {
  .question {
    font-size: 24px;
  }
  .feedback {
    font-size: 24px;
  }
}
.popupLink {
  cursor: pointer;
  color: #000;
  text-decoration: underline;
}
.modal-wrapper {
  background: #ffffff;
}
.selected {
  color: #000;
}
.hidden {
  display: none;
}
.hash {
  font-weight: 700;
}
/*# sourceMappingURL=question.component.css.map */
